// extracted by mini-css-extract-plugin
module.exports = {"top":"layout-module--top--3lMZ1","table":"layout-module--table--3J_jQ"};